module.exports = __webpack_public_path__ + "img/zaoyin.b219044d.png";